import Axios from "./axios.js";
import {bellConstants, bellMusicApiConstants, fileApiConstants, schoolConstants} from "./constants/ApiConstant.js";

export async function uploadFile(params, type) {
    // `type` categorises the upload on the backend (e.g. "announcement"); sent
    // as a query param so the multipart body stays a plain file upload.
    const url = type ? `${fileApiConstants.UPLOAD_FILE}?type=${encodeURIComponent(type)}` : fileApiConstants.UPLOAD_FILE;
    return Axios.post(url, params);
}

export async function uploadFileList(params) {
    return Axios.post(fileApiConstants.UPLOAD_FILES,params);
}

export async function fetchSchoolListForDropdown() {
    return Axios.get(schoolConstants.FETCH_SCHOOL_FOR_DROPDOWN);
}

export async function searchBellQueue() {
    return Axios.get(bellConstants.BELL_QUEUE);
}

export async function fetchBellMusicForDropDown() {
    return Axios.get(bellMusicApiConstants.BELL_MUSIC_FOR_DROPDOWN);
}



